import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/kcc/sales-orders");

export const Route = createFileRoute("/kcc/sales-orders")({
  head: () => ({
    meta: [
      { title: "KCC sales orders — LevelLoad" },
      { name: "description", content: "KCC sales orders — LevelLoad transport planning." },
      { property: "og:title", content: "KCC sales orders — LevelLoad" },
      { property: "og:description", content: "KCC sales orders — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
